module.exports = __webpack_public_path__ + "img/mitsumetro.d35412c6.jpg";